// extracted by mini-css-extract-plugin
export default {"root":"AddEducation_root__2d3J2","form":"AddEducation_form__PTN-e","lastRow":"AddEducation_lastRow__NPh6r","button":"AddEducation_button__5PwQZ"};